import React from 'react';
import cx from 'classnames';
import Styles from './index.module.scss';

interface IDialog {
  visible: boolean;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonType?: 'danger' | 'primary';
  onConfirm?: () => void;
  onCancel?: () => void;
}

const Dialog = ({
  visible,
  title,
  description,
  confirmText = '确定',
  cancelText = '取消',
  confirmButtonType = 'primary',
  onConfirm,
  onCancel,
}: IDialog) => {
  if (!visible) return null;

  return (
    <div className={Styles.root}>
      <div className={Styles.mask} onClick={onCancel} />
      <div className={Styles.main}>
        <div className={Styles.content}>
          <p className={Styles.title}>{title}</p>
          {description && <p className={Styles.description}>{description}</p>}
          <div className={Styles.buttonsWrapper}>
            <button className={Styles.cancelBtn} onClick={onCancel}>{cancelText}</button>
            <button
              className={cx(Styles.confirmBtn, {
                [Styles.dangerBtn]: confirmButtonType === 'danger',
              })}
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
